<template>
  <!-- style="max-width:300px; height:100%; object-fit:cover" -->
  <img :src="src"/>
</template>

<script>
import { getFile } from "@/api/staff";

export default {
  props: {
    path: {
      type: String,
      required: true
    }
  },
  computed: {
    storageKey() {
      const p = this.path.replace('/', '-');
      return `auth-image-${p}`;
    },
    src() {
      const store = this.$store.state.storage.data;
      const key = this.storageKey;
      if(store[key])
        return store[key];
      return null;
    }
  },
  mounted() {
    if(this.path.length < 1)
      return;
    this.fetchImage();
  },
  methods: {
    async fetchImage() {
      if(this.src)
        return;
      const response = await getFile(this.path);
      let url = URL.createObjectURL(response.data);
      this.$store.dispatch('AddStorage', {key: this.storageKey, value: url});
    }
  }
}
</script>